export default "__VITE_ASSET__CBFQuyre__"